import React from "react";
import ReactDOM from "react-dom";
import "./App.scss";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./utils/stores/AuthStore";
import { CustomerProvider } from "./utils/stores/CustomerStore";

ReactDOM.render(
  <AuthProvider>
    <CustomerProvider>
      <App />
    </CustomerProvider>
  </AuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
